module.exports = __webpack_public_path__ + "media/home/eStore_Icon_Brands-bd6ef2eb.png";